/* eslint-disable react/jsx-no-undef */
import { FC, useState } from "react";
import Image from "next/image";
import { Command, CommandEmpty, CommandInput, CommandItem, CommandList } from "@/components/ui/command";
import { Button } from "components/atoms/Button";
import { ButtonType } from "components/atoms/Button/types";
import { QuestionIcon } from "components/atoms/Icon";
import { Modal } from "components/atoms/Modal/index";
import { PresetTooltip } from "components/molecules/Tooltip/PresetTooltip";
import { IPresetDTO } from "types";
import { Span, SubTitle } from "utils/styling/typography.styled";
import { Container, Icon, ModalContainer, TitleContainer } from "./SavePresetModal.styled";
interface SavePresetModalProps {
  isOpen: boolean;
  onCancel: () => void;
  presets: IPresetDTO[];
  onSave: (presetName: string) => void;
}
export const SavePresetModal: FC<SavePresetModalProps> = ({
  isOpen,
  onCancel,
  presets,
  onSave
}) => {
  const [inputValue, setInputValue] = useState("");
  const [filteredOptions, setFilteredOptions] = useState(presets);
  const handleInputChange = (value: string) => {
    setInputValue(value);
    const filtered = presets.filter(preset => preset.name.toLowerCase().includes(value.toLowerCase()));
    setFilteredOptions(filtered);
  };
  const handleSelect = (value: string) => {
    setInputValue(value);
  };
  const handleSaveClick = () => {
    if (inputValue) {
      onSave(inputValue);
    }
  };
  return <Modal open={isOpen} handleBackdropClick={onCancel} disableBackdropClick data-sentry-element="Modal" data-sentry-component="SavePresetModal" data-sentry-source-file="index.tsx">
            <ModalContainer data-sentry-element="ModalContainer" data-sentry-source-file="index.tsx">
                <TitleContainer data-sentry-element="TitleContainer" data-sentry-source-file="index.tsx">
                    <SubTitle data-sentry-element="SubTitle" data-sentry-source-file="index.tsx">Save Preset</SubTitle>
                    <Icon aria-label="Learn more about Premium Content" onClick={e => {
          e.preventDefault();
          e.stopPropagation();
        }} data-sentry-element="Icon" data-sentry-source-file="index.tsx">
                        <Image priority src={QuestionIcon} alt="Tooltip" data-tooltip-id="presetTip" data-sentry-element="Image" data-sentry-source-file="index.tsx" />

                        <PresetTooltip data-sentry-element="PresetTooltip" data-sentry-source-file="index.tsx" />
                    </Icon>
                </TitleContainer>
                <Command data-sentry-element="Command" data-sentry-source-file="index.tsx">
                    <CommandInput placeholder="Select or create a new preset" value={inputValue} onValueChange={handleInputChange} data-sentry-element="CommandInput" data-sentry-source-file="index.tsx" />
                    <CommandList data-sentry-element="CommandList" data-sentry-source-file="index.tsx">
                        <CommandEmpty data-sentry-element="CommandEmpty" data-sentry-source-file="index.tsx">No presets found.</CommandEmpty>
                        {filteredOptions.map(preset => <CommandItem key={preset.id} onSelect={() => handleSelect(preset.name)}>
                                {preset.name}
                            </CommandItem>)}
                    </CommandList>
                </Command>
                <hr />
                <Container data-sentry-element="Container" data-sentry-source-file="index.tsx">
                    <Button onClick={handleSaveClick} variant={ButtonType.SUCCESS} type="button" data-sentry-element="Button" data-sentry-source-file="index.tsx">
                        <Span data-sentry-element="Span" data-sentry-source-file="index.tsx">Save</Span>
                    </Button>
                    <Button type="button" variant={ButtonType.PRIMARY} onClick={onCancel} data-sentry-element="Button" data-sentry-source-file="index.tsx">
                        <Span data-sentry-element="Span" data-sentry-source-file="index.tsx">Cancel</Span>
                    </Button>
                </Container>
            </ModalContainer>
        </Modal>;
};